import {html} from "lit";
import styles from "./icons.scss?inline"

export class Icon {

  public renderChevronDown() {
    return html`
      <style>${styles}</style>
      <svg class="clickable-svg" id="chevron-down" xmlns="http://www.w3.org/2000/svg"
           viewBox="0 0 512 512">
        <path fill="#66666" class="fa-secondary" opacity=".4"
              d="M278.6 406.6c-12.5 12.5-32.8 12.5-45.3 0l-192-192c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L256 338.7 425.4 169.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-192 192z"/>
      </svg>
    `;
  }

  public renderChevronUp() {
    return html`
      <style>${styles}</style>
      <svg class="clickable-svg" id="chevron-up" xmlns="http://www.w3.org/2000/svg"
           viewBox="0 0 512 512">
        <path fill="#66666" class="fa-secondary" opacity=".4"
              d="M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"/>
      </svg>
    `;
  }

  public renderPhone() {
    return html`
      <style>${styles}</style>
      <svg id="phone" viewBox="0 0 512 512">
        <path fill="#555555"
              d="M347.1 24.6c7.7-18.6 28-28.5 47.4-23.2l88 24C499.9 30.2 512 46 512 64c0 247.4-200.6 448-448 448c-18 0-33.8-12.1-38.6-29.5l-24-88c-5.3-19.4 4.6-39.7 23.2-47.4l96-40c16.3-6.8 35.2-2.1 46.3 11.6L207.3 368c70.4-33.3 127.4-90.3 160.7-160.7L318.7 167c-13.7-11.2-18.4-30-11.6-46.3l40-96z"/>
      </svg>
    `;
  }

  public renderMyLocation() {
    return `
      <style>${styles}</style>
      <svg class="clickable-svg" id="my-location" viewBox="0 0 448 512">
        <path fill="#555555"
              d="M429.6 92.1c4.9-11.9 2.1-25.6-7-34.7s-22.8-11.9-34.7-7l-352 144c-14.2 5.8-22.2 20.8-19.3 35.8s16.1 25.8 31.4 25.8l176 0 0 176c0 15.3 10.8 28.4 25.8 31.4s30-5.1 35.8-19.3l144-352z"/>
      </svg>
    `;
  }

  public renderHeartRed() {
    return html`
      <style>${styles}</style>
      <svg id="heart-red" viewBox="0 0 512 512">
        <path fill="#E2001A"
              d="M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z"/>
      </svg>
    `;
  }

  public renderHeartGrey() {
    return html`
      <style>${styles}</style>
      <svg id="heart-grey" viewBox="0 0 512 512">
        <path fill="#555555"
              d="M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z"/>
      </svg>
    `;
  }

  public renderNavigation() {
    return html`
      <style>${styles}</style>
      <svg id="navigation" viewBox="0 0 512 512">
        <path fill="#555555"
              d="M227.7 11.7c15.6-15.6 40.9-15.6 56.6 0l216 216c15.6 15.6 15.6 40.9 0 56.6l-216 216c-15.6 15.6-40.9 15.6-56.6 0l-216-216c-15.6-15.6-15.6-40.9 0-56.6l216-216zm87.6 137c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8v56H224c-35.3 0-64 28.7-64 64v48c0 13.3 10.7 24 24 24s24-10.7 24-24V280c0-8.8 7.2-16 16-16h64v56c0 6.5 3.9 12.3 9.9 14.8s12.9 1.1 17.4-3.5l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80z"/>
      </svg>
    `;
  }

  public renderSearch() {
    return html`
      <style>${styles}</style>
      <svg id="search" viewBox="0 0 512 512">
        <path fill="#B2B2B2"
              d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352c79.5 0 144-64.5 144-144s-64.5-144-144-144S64 128.5 64 208s64.5 144 144 144z"/>
      </svg>
    `;
  }

  public renderClose() {
    return html`
      <style>${styles}</style>
      <svg class="clickable-svg" id="close" viewBox="0 0 512 512">
        <path fill="#888888"
              d="M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z"/>
      </svg>
    `;
  }

  public renderCloseCircle() {
    return html`
      <style>${styles}</style>
      <svg class="clickable-svg" id="close-circle" viewBox="0 0 512 512">
        <path fill="#888888"
              d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm101.8-262.2L295.6 256l62.2 62.2c4.7 4.7 4.7 12.3 0 17l-22.6 22.6c-4.7 4.7-12.3 4.7-17 0L256 295.6l-62.2 62.2c-4.7 4.7-12.3 4.7-17 0l-22.6-22.6c-4.7-4.7-4.7-12.3 0-17l62.2-62.2-62.2-62.2c-4.7-4.7-4.7-12.3 0-17l22.6-22.6c4.7-4.7 12.3-4.7 17 0l62.2 62.2 62.2-62.2c4.7-4.7 12.3-4.7 17 0l22.6 22.6c4.7 4.7 4.7 12.3 0 17z"/>
      </svg>
    `;
  }

  public renderBackArrow() {
    return html`
      <style>${styles}</style>
      <svg class="clickable-svg" id="back-arrow" viewBox="0 0 512 512">
        <path fill="#555555"
              d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/>
      </svg>
    `;
  }

  public renderError() {
    return html`
      <style>${styles}</style>
      <svg id="error" viewBox="0 0 512 512">
        <path fill="#1d508d"
              d="M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm32 224c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32z"/>
      </svg>
    `;
  }

  public renderPlaces() {
    return html`
      <style>${styles}</style>
      <svg id="places" viewBox="0 0 640 640">
          <path d="M128 252.6C128 148.4 214 64 320 64C426 64 512 148.4 512 252.6C512 371.9 391.8 514.9 341.6 569.4C329.8 582.2 310.1 582.2 298.3 569.4C248.1 514.9 127.9 371.9 127.9 252.6zM320 320C355.3 320 384 291.3 384 256C384 220.7 355.3 192 320 192C284.7 192 256 220.7 256 256C256 291.3 284.7 320 320 320z"/>
      </svg>
    `;
  }

  public renderNYer() {
    return html`
      <style>${styles}</style>
      <svg id="nyer" viewBox="0 0 132 122" height="122" width="132">
          <path fill="#E2001A" d="M66 8 Q29 8 29 54 Q29 88 66 107 Q103 88 103 54 Q103 8 66 8Z"></path>
          <text letter-spacing="-3.6px" text-anchor="middle" fill="white" font-weight="900" font-size="27" font-family="Arial Black, Impact, sans-serif" y="61.5" x="66">
              NYer
          </text>
      </svg>
    `;
  }

  public renderPNG(src: string) {
    return html`
      <style>${styles}</style>
      <img id="png" src="${src}">
    `;
  }
}



export const icons = new Icon();
